import React, { useEffect, useState } from 'react';
import Student from "../Assest/student.webp";
import DigitalMarketer from "../Assest/digital-marketer.webp";
import Entrepreneur from "../Assest/self-employee-1.webp";
import Dropshipper from "../Assest/img14.webp";
import Freelancer from "../Assest/freelancer-1.webp";
import AgencyOwner from "../Assest/agency-owner.webp";
import SelfEmployee from "../Assest/self-employee-1.webp";
import JobProfessional from "../Assest/job.webp";
import SmallBusinessOwner from "../Assest/small-business-owner.webp";
import Img from "../Assest/img13.webp";
import RequestAccess from "../components/RequestAccess";

const personas = [
  { label: "Business Owners & Entrepreneurs", image: SmallBusinessOwner},
  { label: "Social Media Managers", image: DigitalMarketer },
  { label: "Content Writers & Copywriters", image: Entrepreneur },
  { label: "Bloggers & Influencers", image: Dropshipper },
  { label: "Students & Competitive Exam Aspirants", image: Student },
  { label: "Teachers & Educators", image: AgencyOwner },
  { label: "Job Seekers & Career Changers", image: SelfEmployee },
  { label: "Freelancers & Digital Marketers", image: JobProfessional },
  { label: "Website Designers & Developers", image: Freelancer },
  { label: "Video Creators & Scriptwriters", image: Img },
  { label: "UI/UX Designers", image: Freelancer },
  { label: "Coaches & Trainers", image: Student },
];


const PersonaCard = ({ image, label }) => (
  <div style={styles.card}>
    <img src={image} alt={label} style={{ height: 120 }} />
    <h3 style={styles.label}>{label}</h3>
  </div>
);

const AudienceSection = () => {
   const [showForm, setShowForm] = useState(false);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [isTablet, setIsTablet] = useState(window.innerWidth > 768 && window.innerWidth <= 1024);
  
    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 768);
        setIsTablet(window.innerWidth > 768 && window.innerWidth <= 1024);
      };
  
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
  
  return (
      <>
    {/* Keyframe animation for button */}
      <style>{`
        @keyframes wiggle {
          0% { transform: translateX(0); }
          25% { transform: translateX(-5px); }
          50% { transform: translateX(5px); }
          75% { transform: translateX(-5px); }
          100% { transform: translateX(0); }
        }
        .wiggle-button {
          animation: wiggle 0.5s ease-in-out infinite;
        }
      `}</style>
    <div style={styles.container}>
      <h2 style={styles.topHeading}>Who Can Buy This Master ChatGPT  <span style={{color:'#DEA15B'}}>Course + 3000 Prompts? </span></h2>

      <div style={styles.grid}>
        {personas.map((p) => (
          <PersonaCard key={p.label} {...p} />
        ))}
      </div>

      <p style={styles.text}>
        And anyone wanting to grow faster, work smarter, and achieve more with the power of ChatGPT{" "}
        
      </p>

      {/* Button */}
            <div style={{ textAlign: 'center', marginTop: '40px' }}>
              <button
                className="wiggle-button"
                style={{
                  background: 'linear-gradient(to right, #f8b500, #e68a00)',
                  color: 'black',
                  fontSize: isMobile ? '18px' : '20px',
                  padding: isMobile ? '12px 30px' : '14px 40px',
                  border: 'none',
                  borderRadius: '14px',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  marginBottom:'30px',
                  width: isMobile ? '100%' : '60%',
                }}
                onClick={() => setShowForm(true)}
              >
                Just ₹199 Limited Time Only
              </button>
            </div>
            
    </div>
            {/* Popup Form */}
          {showForm && <RequestAccess onClose={() => setShowForm(false)} />}
    </>
  );
};

const styles = {
  container: {
    background: 'radial-gradient(107.67% 107.67% at 50% 20.81%, #000B3E 0%, #020202 100%)',
    color: "#fff",
    padding: "40px 20px",
    textAlign: "center",
  },
  topHeading: {
    fontSize: 32,
    fontWeight: "bold",
    marginBottom: 30,
  },
  grid: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: 20,
    marginBottom: 40,
  },
  card: {
    background: "linear-gradient(to bottom, #1a1a1a, #2e2e2e)",
    padding: 20,
    borderRadius: 10,
    width: 220,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  label: {
    fontSize: 20,
    marginTop: 10,
    fontWeight: "bold",
  },
  text: {
    color: "#ccc",
    fontSize: 18,
    maxWidth: 900,
    margin: "0 auto 20px",
  },
  underline: {
    textDecoration: "underline",
  },
  heading: {
    fontSize: 32,
    fontWeight: "bold",
    marginTop: 10,
  },
};

export default AudienceSection;
